import { OnInitProvider } from './onInit';

export * from './useOnBehalf';
export * from './usePrevious';
export * from './useUserData';
export * from './useKnowledgePermission';
export * from './usePcManagementPermission';
export * from './usePclDescriptions';
export * from './useAttachmentConfig';
export * from './useMarketplacePermissions';
export * from './useDynamicFormDescs';
export * from './useDelegationApprovalDialogDescs';
export * from './useBlockHistory';
export * from './useLanguageCode';
export * from './useTicketFilter';
export * from './useManageDevicesFilter';
export * from './useKnowledgeFilter';
export * from './useRequestsApprovalFilter';
export * from './usePclDeviceId';
export * from './usePermission';
export * from './useDocumentTitle';
export * from './useDeliverySettings';
export * from './useCheckEmail';
export * from './useNoScanReasons';

export const HooksProvider = {
  ...OnInitProvider,
};
